import type React from 'react';
import type { LineChartData } from '../types';

type TooltipData = LineChartData & Record<string, unknown>;

type CustomTooltipProps = {
  active?: boolean;
  payload?: { payload: TooltipData }[];
  renderTooltip?: (data: LineChartData) => React.ReactNode;
  primaryColor?: string;
  formatValue?: (value: number) => string;
};

// const CustomTooltip = ({ active, payload, label, renderTooltip }) => {
export const CustomTooltip = ({
  active,
  payload,
  renderTooltip,
  primaryColor,
  formatValue,
}: CustomTooltipProps) => {
  const show = (value: unknown) =>
    formatValue ? formatValue(Number(value ?? 0)) : String(value);
  if (active && payload && payload.length) {
    const data = payload[0]?.payload;
    if (!data) return null;

    if (renderTooltip) {
      return (
        <div className="border-border bg-background flex items-center gap-2 rounded border p-4">
          {renderTooltip(data)}
        </div>
      );
    }
    return (
      <div
        className="border-border bg-background text-primary flex items-center gap-2 rounded border p-4"
        style={{ color: primaryColor }}
      >
        <div className="flex flex-col">
          <span className="">{`${data.name}`}</span>
          <span className="text-2xl font-extrabold">{show(data.count)}</span>
        </div>
        {data.prevName ? (
          <div className="flex flex-col text-gray-400">
            <span className="">{String(data.prevName)}</span>
            <span className="text-2xl font-extrabold">
              {show(data.prevCount)}
            </span>
          </div>
        ) : null}
      </div>
    );
  }

  return null;
};
